module.exports = __webpack_public_path__ + "static/media/flatbread-product-4.cb4b7f38.svg";